<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/90/title-bg.png" alt="" />
      <div class="technological-process">
        
        <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/90/title-1.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    （一）支持院士团队围绕我省创新优势领域，领衔建设省级重点实验室、技术创新中心等研究平台，对新建的四川省重点实验室给予50万元经费补助，对已建的四川省重点实验室年度考核优秀的给予50万元经费补助、周期评估优秀的给予80万元经费补助。
                  <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86763106">028-86763106</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            人社厅专技处
                        </div>
                  </div>
                </div>
                <div class="des">
                  
                    （二）鼓励院士牵头整合优化省级创新平台，对纳入国家规划布局的国家实验室和国家技术创新中心，统筹省级财政科技计划和中央引导地方科技发展专项资金分年度给予总额1亿元的经费支持；对新建的省部共建国家重点实验室，在建设运行期内给予每年1000万元经费支持；对新建的国家重点实验室给予1000万元经费支持；对新建的省级院士工作站每个给予50万元资助，对绩效评估优秀的给予20万元奖励；对新入选的省级院士（专家）产业园每个给予不超过300万元的一次性资助。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86763106">028-86763106</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            人社厅专技处
                        </div>
                  </div>
                </div>
                <div class="des">
                    
                    （三）经批准建立的省级院士工作站、专家工作站，从四川省科普专项资金中分别给予每个院士工作站50万元、每个专家工作站25万元的一次性经费资助，对绩效评估优秀的院士（专家）工作站给予20万元的奖励资助。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86763106">028-86763106</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            人社厅专技处
                        </div>
                  </div>
                </div>
                <div class="des">
                    （四）对重点产业园区、企业新增省级博士后科研工作站或博士后创新实践基地给予20万元资助，新建省级技能大师工作室、院士工作站、院士（专家）产业园分别给予30万元、50万元、300万元资助。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86763106">028-86763106</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            人社厅专技处
                        </div>
                  </div>
                </div>
                <div class="des">
                    （五）编制科技成果转化年度报告，每年遴选一批科技成果转化项目和创新产品项目，给予每个项目30万元至200万元资助。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86728520">028-86728520</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            科技厅人事处
                        </div>
                  </div>
                </div>
                <div class="des">
                    （六）企业人才以我省单位为第一完成单位取得科技成果，获国家自然科学、技术发明、科技进步奖的，按1:1给予配套奖励。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86728520">028-86728520</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            科技厅人事处
                        </div>
                  </div>
                </div>
                <div class="des">
                    （七）对高层次人才创办企业或核心成果转化情况进行动态跟踪支持，其企业或成果在三年内实现营业收入首次超过5000万元、1亿元、2亿元的，综合质量效益情况分别给予最高50万元、100万元、300万元奖励。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86262785">028-86262785</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            经信厅创业促进与服务体系处
                        </div>
                  </div>
                </div>
                <div class="des">
                    （八）省级重大人才计划入选人员所在用人单位通过自行转化、转让、许可、作价入股等方式转移转化职务科技成果，其转化收益按不低于70%的比例奖励作为成果完成人的入选人员及其团队。
                  <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86728520">028-86728520</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            科技厅人事处
                        </div>
                  </div>  
                </div>
                <div class="des">
                    （九）高校科技人员取得职务科技成果转化现金奖励，符合规定条件的可减按50%计入科技人员当月工资薪金所得缴纳个人所得税。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86111514">028-86111514</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            教育厅党建与干部人才处
                        </div>
                  </div>  
                </div>
                <div class="des">
                    （十）对引进急需紧缺的高层次人才的特殊报酬，包括省级政府奖励和按规定发放的安家费等，其应缴纳的个人所得税依法予以减免。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86111514">028-86111514</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            教育厅党建与干部人才处
                        </div>
                  </div> 
                </div>
                <div class="des">
                    （十一）鼓励大学生服务基层项目人员留在当地，对服务期满、考核合格的，可直接考核招聘到服务所在县（市、区）的乡镇事业单位；在民族地区、艰苦边远地区和贫困县服务的，可直接考核招聘到服务所在县（市、区）的县乡事业单位。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86761165">028-86761165</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            人社厅事业单位人事管理处
                        </div>
                  </div> 
                </div>
            </div>
        </div>
        <!-- <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/89/title-6.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    <div class="title">
                      <div class="circle" style="marginRight:0.1rem"></div>
                      （一）支持引进科技创新领军人才
                    </div>
                    <div>咨询电话：<a href="tel:85145512">85145512</a> 赵老师</div>
                    <div>责任单位：成都高新区科技创新局人才发展处</div>
                </div>
                <div class="des">
                  <div class="title">
                      <div class="circle"></div>
                      （二）支持引进急需产业创新领军人才
                    </div>
                    <div>咨询电话：<a href="tel:62037252">62037252</a> 黄老师</div>
                    <div>责任单位：成都高新区科技创新局人才发展处</div>
                </div>
            </div>
        </div> -->
        <!-- <div class="contact">
          <img class="top" src="./../assets/imgs/84/title-6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88211208">028-88211208</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              县人社局
            </div>
          </div>
        </div> -->
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/89/code.png" />
          <img class="text" src="../assets/imgs/89/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.58rem;
  }
  .technological-process {
    transform: translateY(-2.3rem);
   
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;
      .top {
          width: 7.03rem;
          height: 1.37rem;
          margin-left: -0.18rem;
      }
      
      .content {
          width: 6.85rem;
          background: #D4E0FF;
          margin: -0.45rem auto 0;
          padding: 0.33rem;
          box-sizing: border-box;
          border-radius: 0rem 0rem 0.26rem 0.26rem;
          padding-top: 0.28rem;
          
          font-weight: 500;
          text-align: left;
          color: #4e4e4e;
          
          .des {
              color: #4e4e4e;
              text-align: left;
              background: #ffffff;
              border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
              padding: 0.35rem 0.23rem 0.3rem;
              margin-top: 0.2rem;
              position: relative;
              text-align: left;
              line-height: 0.44rem;
              color: #333333;
              font-size: 0.26rem;
              .title {
                  position: absolute;
                  top: -0.6rem;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 100%;
                  // height: 0.67rem;
                  font-size: 0.34rem;
                  
                  // border: 1px solid red;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .circle{
                    width: 0.22rem;
                    height: 0.22rem;
                    border: 0.06rem solid #FF6D60;
                    border-radius: 50%;
                  }
              }
          }
      }
    }
   
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 0.61rem;
      }
    }
  }
}
</style>
